import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
import store from '@/store';
import { Route } from 'vue-router';

export default [
    {
        path: '/create_team/monitor_info/:activityId',
        name: ROUTE_NAME.CREATE_TEAM_MONITOR_INFO,
        meta: {
            title: (to: Route) => {
                const basicInfo = store.state.activity.basicInfo[to.params.activityId];
                const name = basicInfo ? basicInfo.name : '';
                return `${name}队长信息提交`;
            },
            shareWord: false,
            needBinding: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "create_team" */ '@/pages/createTeam/monitorInfo.vue'),
            loading: Loading,
        }),
    },
    // todo: 是否有必要?
    {
        path: '/create_team/monitor_info',
        redirect(to: Route) {
            return {
                name: ROUTE_NAME.CREATE_TEAM_MONITOR_INFO,
                params: {
                    activityId: '2',
                },
            };
        },
    },
    {
        path: '/create_team/monitor_check/:activityId',
        name: ROUTE_NAME.CREATE_TEAM_MONITOR_CHECK,
        meta: {
            title: (to: Route) => {
                const basicInfo = store.state.activity.basicInfo[to.params.activityId];
                const name = basicInfo ? basicInfo.name : '';
                return `${name}队长信息审核`;
            },
            shareWord: false,
            needBinding: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "create_team" */ '@/pages/createTeam/monitorCheck.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/create_team/team_info',
        redirect: (to: Route) => {
            return {
                name: ROUTE_NAME.CREATE_TEAM_TEAM_INFO,
                params: {
                    activityId: store.getters['activity/activityId'],
                },
            };
        },
    },
    {
        path: '/create_team/team_info/:activityId',
        name: ROUTE_NAME.CREATE_TEAM_TEAM_INFO,
        meta: {
            title: (to: Route) => {
                const basicInfo = store.state.activity.basicInfo[to.params.activityId];
                const name = basicInfo ? basicInfo.name : '';
                return `${name}战队信息提交`;
            },
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "create_team" */ '@/pages/createTeam/teamInfo.vue'),
    },
    {
        path: '/create_team/team_info/:activityId/:teamId', // :teamId 战队id
        redirect: (to: Route) => {
            return {
                name: ROUTE_NAME.MONITOR_SETTING_BEFORE,
                params: to.params,
            };
        },
    },
];
